module.exports = __webpack_public_path__ + "media/images/avatar/development/nannies/12-896429593ae7c1d44aee90d40f9825a3.jpg";